import { render, staticRenderFns } from "./BannerPolicies.vue?vue&type=template&id=57de6bbb"
import script from "./BannerPolicies.vue?vue&type=script&lang=js"
export * from "./BannerPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports